import moment from 'moment';
import ExportJsonExcel from 'js-export-excel';

class RegistersController {
    exportExcel(data) {
        let option = {};  // La opción representa el archivo de Excel
        let registerControl = this.registersControlsPatients(data);
        option.fileName = 'Control de Registros';  // Nombre del archivo Excel
        option.datas = [
            {
                sheetData: registerControl.data,  // Fuente de datos en archivo Excel
                sheetName: 'Control de Registros',  // nombre de la página de hoja en el archivo de Excel
            }
        ]
        let toExcel = new ExportJsonExcel(option);  // Generar archivo de Excel
        toExcel.saveExcel();  // Descargar archivo de Excel

    }

    registersControlsPatients(dataResolution) {
        let dataTable = [];  // Contenido de datos en archivo Excel

        let Titulos = this.generarTituloResolucion();//Titulos del Recibo de Caja
        dataTable.push(Titulos);

        for(let i = 0; i < dataResolution.length; i++)
        {
            let Datos = this.generarDatosControlRegistro(dataResolution[i]);
            dataTable.push(Datos);
        }

        let sheet =
        {
            data: dataTable
        }

        return sheet;
    }

    generarTituloResolucion() {
        let Titulos = {
            '1': 'Fecha',
            '2': "Registro Clinico",
            '3': "Entidad",
            '4': "Paciente",
            '5': "Examen",
            '6': "Recibo de Caja",
            '7': "Copago",
            '8': "Causa de Rechazos"
        }
        return Titulos;
    }

    generarDatosControlRegistro(data) {
        let Titulos = {
            '1': data.fecha_admision,
            '2': data.id_admision,
            '3': data.entidad,
            '4': data.paciente,
            '5': data.servicio,
            '6': data.recibo_caja,
            '7': data.copago,
            '8': data.causa_rechazos
        }
        return Titulos;
    }

}

export default new RegistersController();